import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/common.scss'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueMatomo from 'vue-matomo'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(Vant);

Vue.use(VueMatomo, {
  host: '//statistics.wbball.com/',
  siteId: 2
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
window._paq.push(['trackPageView']);
